import React, { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useUI, useData } from '../context/AppContext';
import { instructorTabPath } from '../navigation/paths';
import StudentDetail from '../pages/instructor/StudentDetail';

/**
 * Öğrenci detay — URL'deki studentId ile selectedStudent senkronu (SRP).
 */
const InstructorStudentRoute = () => {
  const { studentId } = useParams();
  const { students, liveDataReady } = useData();
  const { setSelectedStudent } = useUI();

  const student = students.find((s) => s.id === studentId);

  useEffect(() => {
    if (student) {
      setSelectedStudent(student);
    }
    return () => setSelectedStudent(null);
  }, [student, studentId, setSelectedStudent]);

  if (!liveDataReady) {
    return (
      <div className="p-8 flex items-center justify-center text-slate-400 gap-3">
        <Loader2 size={22} className="animate-spin" />
        <span className="font-bold">Öğrenci yükleniyor...</span>
      </div>
    );
  }

  if (!student) {
    return <Navigate to={instructorTabPath('students')} replace />;
  }

  return <StudentDetail />;
};

export default InstructorStudentRoute;
